import styled from 'styled-components';
import Title from 'gatsby-theme-pdv/src/components/footer/title';

export default styled(Title)`
  color: ${({ theme }) => theme.primaryColor};
  text-transform: uppercase;
`;
